export default __webpack_public_path__ + "static/media/ical.bede58e6.svg";